import LOADER from "../../assets/loader.svg"
import GOLD_LOADER from "../../assets/loader-gold.svg"

const Loader = ({ gold, fullScreen }: { gold?: boolean; fullScreen?: boolean }) => {
  return (
    <div className={fullScreen ? "fixed inset-0 bg-white dark:bg-black flex justify-center items-center z-[9999]" : ""}>
      {gold ? (
        <img src={GOLD_LOADER} className="h-20 w-20" alt="gold loader" />
      ) : (
        <img src={LOADER} alt="loader" />
      )}
    </div>
  )
}

export default Loader
